module.exports = __webpack_public_path__ + "static/media/before_n_after_c.8d3bcaa8.jpg";